import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
/**
 * Dispatched to notify changes in a sub geometry object's state.
 *
 * @class away.events.RenderableEvent
 * @see away.core.base.Graphics
 */
var RenderableEvent = /** @class */ (function (_super) {
    __extends(RenderableEvent, _super);
    /**
     * Create a new GraphicsEvent
     * @param type The event type.
     * @param dataType An optional data type of the vertex data being updated.
     */
    function RenderableEvent(type, renderable) {
        var _this = _super.call(this, type) || this;
        _this._renderable = renderable;
        return _this;
    }
    Object.defineProperty(RenderableEvent.prototype, "renderable", {
        /**
         * The renderobject owner of the renderable owner.
         */
        get: function () {
            return this._renderable;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Clones the event.
     *
     * @return An exact duplicate of the current object.
     */
    RenderableEvent.prototype.clone = function () {
        return new RenderableEvent(this.type, this._renderable);
    };
    /**
     * Dispatched when a Renderable has been updated.
     */
    RenderableEvent.INVALIDATE_MATERIAL = 'invalidateMaterial';
    /**
     *
     */
    RenderableEvent.INVALIDATE_ELEMENTS = 'invalidateElements';
    /**
     *
     */
    RenderableEvent.INVALIDATE_STYLE = 'invalidateStyle';
    return RenderableEvent;
}(EventBase));
export { RenderableEvent };
